import React, { useContext, useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { CommonContext } from "../../context/CommonContext";
import { authHttp } from "../../services/commonHttpService";
import { apisPath } from "../../utils/path";
import {
  calculateAge,
  formatDate,
  formatAbhaId,
} from "../../helpers/commonHelper";

const PatientCard = ({ patientId, patientData: patientDataProp }) => {
  const { setIsLoading, setSnackState } = useContext(CommonContext);
  const [patientData, setPatientData] = useState(patientDataProp || null);
  const [loading, setLoading] = useState(!patientDataProp);

  // Fetch patient details
  const fetchPatientDetails = async () => {
    if (!patientId || patientDataProp) {
      setLoading(false);
      return;
    }

    try {
      const response = await authHttp.get(
        `${apisPath?.patientDetails}/${patientId}`
      );

      if (response?.data?.status || response?.data?.data) {
        setPatientData(response?.data?.data);
      }
    } catch (error) {
      setSnackState({
        open: true,
        message: error?.response?.data?.message || "Failed to fetch patient details",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // If patientData is provided as prop, use it directly
    if (patientDataProp) {
      setPatientData(patientDataProp);
      setLoading(false);
    } else {
      // Otherwise, fetch it
      fetchPatientDetails();
    }
  }, [patientId, patientDataProp]);

  // Get first letter of name for avatar
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "P";
  };

  if (loading) {
    return (
      <div className="card shadow-sm profile-card p-3">
        <div className="row align-items-center">
          <div className="col-3">
            <Skeleton variant="circular" width={60} height={60} />
          </div>
          <div className="col-9">
            <Skeleton variant="text" width="80%" height={24} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={32}
              sx={{ mt: 2, borderRadius: 2 }}
            />
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-between">
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="20%" />
          <Skeleton variant="text" width="30%" />
        </div>
      </div>
    );
  }

  if (!patientData) {
    return (
      <div className="card shadow-sm profile-card p-3">
        <div className="text-center text-muted">
          <p>No patient data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm profile-card p-3">
      <div className="row align-items-center">
        <div className="col-3">
          <div className="avatar-circle">
            {getInitial(patientData?.full_name)}
          </div>
        </div>
        <div className="col-9">
          <h6 className="header-name mb-1">{patientData?.full_name}</h6>
          <span className="pill pink-pill d-block mt-3 mb-3">
            ABHA ID : {formatAbhaId(patientData?.abha)}
          </span>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-between text-muted small">
        <span className="profinle-para">Gender : {patientData?.gender}</span>
        <span>|</span>
        <span className="profinle-para">
          Age : {calculateAge(patientData?.dob)}
        </span>
        <span>|</span>
        <span className="profinle-para">
          DOB : {formatDate(patientData?.dob)}
        </span>
      </div>
    </div>
  );
};

export default PatientCard;
